import { HttpService } from '../http';
import { Application } from './application.interface';

export class ApplicationService {
  public static async getByClientID(client_id: string): Promise<Application> {
    const { data } = await HttpService.get(`/application/${client_id}`);
    return data;
  }
}
